import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function PersonalInjuryPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['personal-injury']} />;
}
